<div class="legal-container p-4 sm:p-6 md:p-8 bg-white shadow-md rounded-lg max-w-4xl mx-auto my-8">
  <h1 class="text-[24px] sm:text-[24px] font-bold text-gray-900 mb-4">
    {{ 'SHARED.LEGAL_TERMS-AND-CONDITIONS.TITLE' | translate }}
  </h1>
  <div [innerHTML]="termsAndConditionsContent"></div>
</div>
